<div class="dropdown--container">
  <ul class="dropdown--base">
    <app-line-item
      *ngFor="let option of options"
      [option]="option"
      (handleClick)="onSelectOption(option)"
    >
    </app-line-item>
  </ul>
</div>
